/**
 * Единица и число для возраста старейшего неотправленного сообщения (`oldestPendingAgeSeconds`).
 * Бэк отдаёт возраст в секундах — это оформление готового числа, а не подсчёт (правило 11): берём
 * крупнейшую целую единицу, остаток отбрасываем. Фразу собирает потребитель по ключу i18n с
 * плюрализацией (`t('age.<unit>', { count })`), поэтому здесь только `{ unit, count }`, без текста.
 */
export type ExchangeAgeUnit = 'second' | 'minute' | 'hour' | 'day'

export type ExchangeAgePart = { unit: ExchangeAgeUnit; count: number }

const MINUTE = 60
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/** Крупнейшая целая единица возраста: секунды → минуты → часы → сутки. Отрицательное — ноль секунд. */
export function exchangeAgePart(seconds: number): ExchangeAgePart {
  const value = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0
  if (value >= DAY) return { unit: 'day', count: Math.floor(value / DAY) }
  if (value >= HOUR) return { unit: 'hour', count: Math.floor(value / HOUR) }
  if (value >= MINUTE) return { unit: 'minute', count: Math.floor(value / MINUTE) }
  return { unit: 'second', count: value }
}
